export function emptyValidator(obj){
    return Object.keys(obj)?.reduce((errors, key) => {
        if(Object.keys(obj[key]).length === 0) {
            errors.push(key)
        }
        return errors
    }, [])
}